import BaseAPI from "../api";

const path: string = "/course-annual-detail";

export type listType = {
  leave_status?: string;
  degree?: string;
  faculty?: string;
  date_of_issue?: string;
  year_graduated?: string;
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
  start_date?: string;
  end_date?: string;
  search?: string;
  id_faculty?: string;
  log_user_type?: string;
  year?: string;
  term?: string
};

export class CourseAnnualDetailAPI extends BaseAPI {
  static getCourseAnnualDetailList(query: listType): Promise<any> {
    return this.api.get(`${path}`, {
      params: { ...query },
    });
  }

  static updateCourseAnnualDetailById(
    id: number,
    body: FormData
  ): Promise<any> {
    return this.api.patch(`${path}/${id}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static getCourseAnnualDetailById(
    id_course_annual_detail: number,
  ): Promise<any> {
    return this.api.get(`${path}/${id_course_annual_detail}`);
  }

  static deleteCourseAnnualDetailById(id_course_annual_detail: number): Promise<any> {
    return this.api.delete(`${path}/${id_course_annual_detail}`);
  }

  static deleteFileCourseAnnualDetailByIdFile(id_course_annual_file: number): Promise<any> {
    return this.api.delete(`${path}/${id_course_annual_file}/file`);
  }

  static createCourseAnnualDetailByIdCourseAnnual(
    id_course_annual: number,
    body: FormData
  ): Promise<any> {
    return this.api.post(`${path}/${id_course_annual}`, body, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static getCourseAnnualListByIdCourseStudy(
    id_course_study: number,
    query: listType
  ): Promise<any> {
    return this.api.get(`${path}/${id_course_study}/get-course-annual`, {
      params: { ...query },
    });
  }

  static getCourseAnnualDetailListByIdCourseAnnual(
    id_course_study: number,
    query: listType
  ): Promise<any> {
    return this.api.get(`${path}/${id_course_study}/get-course-annual-detail`, {
      params: { ...query },
    });
  }

  static getCourseAnnualDetailFile(id_file: number): Promise<any> {
    return this.api.get(`${path}/${id_file}/downloadfile`, {
      responseType: "arraybuffer",
    });
  }

  
}
